const filterMenu = document.querySelectorAll('.filter-menu');

filterMenu.forEach(filter => {
    let clickCounter = 0;
    let selectedFilter = filter.getAttribute('data-filter');

    let menuActive = document.querySelectorAll(`.filter-menu[data-filter="${selectedFilter}"]`);
    let menuNonActive = document.querySelectorAll(`.filter-menu:not([data-filter="${selectedFilter}"])`);

    let itemHide = document.querySelectorAll(`.filter-result:not([data-filter="${selectedFilter}"])`);
    let itemShow = document.querySelectorAll(`.filter-result[data-filter="${selectedFilter}"]`);
    
    filter.addEventListener('click', function (e, arr) {
        clickCounter++;

        itemHide.forEach(el => {
            el.classList.add('hide');
            el.classList.remove('show');
        });

        itemShow.forEach(el => {
            el.classList.remove('hide');
            el.classList.add('show');
        });

        menuNonActive.forEach(el => {
            el.classList.add('nonactive');
            el.classList.remove('active');
        });

        menuActive.forEach(el => {
            el.classList.remove('nonactive');
            el.classList.add('active');
        });

        e.stopPropagation();
    });
});